import styled from "styled-components";

export const SectionTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 400;
  margin: 10px 0;
  display: flex;
  gap: 0.5rem;
`;
